import React, { useState } from 'react';
import Classes from './styles/style.module.css';
import Logo from '../Home/Components/Logo/Logo';

function PrivacyPolicy() {
    return (
        <>
            <div
                className={Classes.navContainer}
                style={{ boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.06)' }}
            >
                <div>
                    <a className={Classes.logoLink} href="/">
                        <Logo alwaysShowText={true} />
                    </a>
                </div>
                <nav className={Classes.navMenu}></nav>
                <div>
                    <a href="/">
                        <h5 className={Classes.goBackTxt}>Go back to Tawaf.ai</h5>
                    </a>
                </div>
            </div>

            <form className={Classes.hero}>
                <h1>Privacy Policy — Tawaf, Inc.</h1>
                <div className={Classes.form_con}>
                    <h5>Version: v1.0</h5>
                    <h5>Effective date: 2025-11-10</h5>
                    <h5>Company: Tawaf, Inc. (Delaware, USA)</h5>
                    <h5>
                        Address: 406 E Tuscaloosa St. Unit 1, Florence, AL 35630, USA
                    </h5>
                    <h5>
                        Privacy contact / DPO:{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>At a glance</h5>
                    <ul>
                        <li>
                            <h5>
                                We collect only what’s needed to run Tawaf (accounts, basic usage,
                                optional location, optional messaging, optional bookings).
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Location sharing is opt-in and can be turned off any time.
                            </h5>
                        </li>
                        <li>
                            <h5>Data is encrypted in transit and at rest.</h5>
                        </li>
                        <li>
                            <h5>You can request access or deletion of your data.</h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>What this policy covers</h5>
                    <h5>
                        This policy explains how Tawaf, Inc. (“Tawaf,” “we,” “us”) handles personal
                        data for our website and apps. For any B2B/white-label deployments, we act
                        as a processor for that client; otherwise we are the controller.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Data we collect</h5>
                    <h5>We collect several types of information to run and improve Tawaf:</h5>
                    <br />

                    <h5 className={Classes.mini_title}>a. You provide</h5>
                    <ul>
                        <li>
                            <h5>
                                Name, email/phone, password (hashed), and preferred language.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Profile information, groups you create or join, and messages you
                                send.
                            </h5>
                        </li>
                        <li>
                            <h5>Support requests or other communications you send us.</h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.mini_title}>b. Optional sensitive data (off by default)</h5>
                    <ul>
                        <li>
                            <h5>
                                Vaccination or travel document information.{' '}
                                <strong>[Not collected at launch]</strong>
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.mini_title}>c. Information we collect automatically</h5>
                    <ul>
                        <li>
                            <h5>
                                Device and app information, IP address, and basic technical data.
                            </h5>
                        </li>
                        <li>
                            <h5>General analytics and crash logs to improve reliability.</h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.mini_title}>d. Location (opt-in)</h5>
                    <ul>
                        <li>
                            <h5>
                                Precise GPS location for navigation and Group Location Sharing when
                                you enable it.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.mini_title}>e. From partners</h5>
                    <ul>
                        <li>
                            <h5>
                                Booking and payment metadata from payment processors or travel
                                partners (we do not store full card numbers).
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>How we use data (plain English)</h5>
                    <h5>We use your data to:</h5>
                    <br />

                    <ul>
                        <li>
                            <h5>
                                Run the service: accounts, routing, groups, chat/calls, and basic
                                personalization.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Maintain safety and prevent misuse (rate limiting, spam/abuse
                                detection).
                            </h5>
                        </li>
                        <li>
                            <h5>Improve reliability through analytics and crash reporting.</h5>
                        </li>
                        <li>
                            <h5>
                                Manage advertising/sponsorships if enabled in the future. At launch
                                this is off; if enabled, we start with contextual ads only unless
                                you consent otherwise.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Handle payments and bookings through third-party processors.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>
                        Location &amp; Group Location Sharing (important)
                    </h5>
                    <ul>
                        <li>
                            <h5>
                                Location sharing is off by default. You choose when to share and
                                with which group(s).
                            </h5>
                        </li>
                        <li>
                            <h5>
                                You can stop sharing at any time and may use “hide/ghost” modes if
                                available.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                We process live location for the active session only; location
                                history is <strong>OFF at launch</strong>.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                Misuse of location features (for example, stalking or harassment) is
                                prohibited and may result in suspension.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>Cookies &amp; SDKs (simple)</h5>
                    <h5>
                        We use minimal cookies and SDKs for login, performance, and crash reporting.
                        In regions where consent is required (for example, EU/UK), we show a consent
                        banner and honor your choices. Some SDKs may process data outside your
                        country.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Legal grounds &amp; your rights</h5>
                    <h5>
                        Where required (e.g., EU/UK), we rely on:
                    </h5>
                    <br />
                    <ul>
                        <li>
                            <h5>
                                <strong>Consent</strong> for location and certain analytics.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Contract or legitimate interests</strong> to provide and run
                                the service.
                            </h5>
                        </li>
                    </ul>
                    <br />
                    <h5>
                        Depending on your region, you may have rights to access, correct, delete, or
                        export your data, and to object to or opt out of certain uses. To exercise
                        these rights, contact{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>International transfers</h5>
                    <h5>
                        If your data is transferred across borders, we use standard safeguards such
                        as Standard Contractual Clauses (SCCs) and the UK IDTA with our vendors
                        where required.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Retention</h5>
                    <h5>We keep data only as long as needed for the purposes described:</h5>
                    <br />

                    <ul>
                        <li>
                            <h5>
                                <strong>Account / profile:</strong> While your account is active +
                                12 months.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Messages:</strong> 30 days or until you delete them.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Location history:</strong> Off at launch.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Booking / payment metadata:</strong> 7 years (for tax and
                                audit purposes).
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Logs / analytics:</strong> Typically 90 days.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>Support tickets:</strong> Typically 3 years.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>Security (high level)</h5>
                    <h5>
                        We use encryption in transit and at rest, least-privilege access, basic
                        network segmentation, logging, backups, and a documented incident response
                        process to protect your data.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Children</h5>
                    <h5>
                        Tawaf is designed for adults. Minors may use the service only with
                        parental/guardian consent where permitted by law. Parents or guardians can
                        request deletion of a child’s data by contacting{' '}
                        <a href="mailto:support@tawaf.ai">support@tawaf.ai</a>.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Sub-processors</h5>
                    <h5>
                        We use common vendors for hosting, analytics, crash reporting, maps,
                        voice/translation, messaging/VoIP, and payments.
                    </h5>
                    <br />
                    <h5>Representative examples (to be finalized post-launch):</h5>
                    <ul>
                        <li>
                            <h5>
                                <strong>[CloudHost]:</strong> Hosting/CDN (US/EU), with DPA + SCCs
                                where applicable.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>[MapsAPI]:</strong> Maps &amp; routing (Global), with DPA.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>[AnalyticsCo]:</strong> Analytics (US/EU), DPA + consent
                                where required.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>[CrashlyticsCo]:</strong> Crash reporting (US/EU), DPA.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>[VoiceAI]:</strong> Speech-to-text / translation (US/EU),
                                DPA.
                            </h5>
                        </li>
                        <li>
                            <h5>
                                <strong>[PaymentsCo]:</strong> Payment processing (US/EU), DPA.
                            </h5>
                        </li>
                    </ul>

                    <br />

                    <h5 className={Classes.major_title}>Changes &amp; contact</h5>
                    <h5>
                        We may update this Privacy Policy from time to time. We will post updates
                        here and, if changes are material, we may notify you in-app or by email.
                    </h5>
                    <br />
                    <h5>
                        Contact: <a href="mailto:support@tawaf.ai">support@tawaf.ai</a> <br />
                        406 E Tuscaloosa St. Unit 1, Florence, AL 35630, USA
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Regional note (MVP)</h5>
                    <h5>
                        We aim to comply with GDPR/UK GDPR, CPRA (California), Saudi PDPL, and UAE
                        PDPL at a baseline level. Where local rules differ, we will follow them and
                        honor your rights accordingly.
                    </h5>

                    <br />

                    <h5 className={Classes.major_title}>Human summary</h5>
                    <h5>
                        We collect the minimum needed to run Tawaf. Location is opt-in. Data is
                        encrypted. You control your data — contact us for access or deletion.
                    </h5>

                    <br />
                </div>
            </form>
        </>
    );
}

export default PrivacyPolicy;
